/**
 * Small squared organization mark for the Name column — same 8px-radius
 * square + image-or-initials pattern as AppShell/WorkspaceSwitcher's
 * SquareAvatar (not imported directly: that one is a local, unexported
 * sub-component of a sidebar-specific file). Promote to a shared
 * theme/untitled component if a third caller needs this exact pattern.
 *
 * @param {string} name
 * @param {string=} iconUrl
 */
import React from "react";
import { initialsFromName } from "../../templates/PageTemplate/useAccountShellData";
import styles from "./OrganizationsPage.module.scss";

const OrgLogo = ({ name, iconUrl }) =>
  iconUrl ? (
    <img src={iconUrl} alt={name} className={styles.orgLogo} />
  ) : (
    <span className={styles.orgLogo} aria-hidden="true">
      {initialsFromName(name)}
    </span>
  );

export default OrgLogo;
